// mui
import { Grid, Typography } from '@mui/material';
// form
import { useForm } from 'react-hook-form';
// little-state-machine
import { useStateMachine } from 'little-state-machine';
// component
import {
  FieldCondition,
  FormProvider,
  RHFTextField,
  RHFSelect,
} from '../../../../components/hook-form';
import FormSectionControls from '../../FormSectionControls';
// hooks
import useFormStateUpdateOnChange from '../../../../hooks/useFormStateUpdateOnChange';

// -------------------------------------------------------

const Form = () => {
  // state
  const { state } = useStateMachine();

  // form
  const methods = useForm({
    mode: 'onChange',
    defaultValues: state.form,
  });

  const { watch } = methods;
  
  // styles
  const detailsFieldStyle = {
    marginLeft: 40,
  };
  
  const handleChosenChange = (value, field) => {
    methods.setValue(`${field}.chosen`, value);
    if (value !== 'Yes') {
      methods.setValue(`${field}.details`, null);
    }
  };



  useFormStateUpdateOnChange(watch);

  return (
    <FormProvider methods={methods}>
      <Grid container spacing={2}>
        <Grid item xs={11}/>
        <Grid item xs={1}>
          <Typography>Yes / No</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>1. DOES APPLICANT OWN, OPERATE OR LEASE AIRCRAFT / WATERCRAFT?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.doesApplicantOwnOperateOrLeaseAircraftWatercraft'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>2. DO / HAVE PAST, PRESENT OR DISCONTINUED OPERATIONS INVOLVE(D) STORING, TREATING, DISCHARGING, APPLYING, DISPOSING, OR TRANSPORTING OF HAZARDOUS MATERIAL?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.havePastPresentOrDiscontinuedOperations'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>3. ANY WORK PERFORMED UNDERGROUND OR ABOVE 15 FEET?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyWorkPerformedUndergroundOrAbove15Feet'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>4. ANY WORK PERFORMED ON BARGES, VESSELS, DOCKS, BRIDGE OVER WATER?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyWorkPerformedOnBargesVesselsDocksBridgeOverWater'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>5. IS APPLICANT ENGAGED IN ANY OTHER TYPE OF BUSINESS?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.isApplicantEngagedInAnyOtherTypeOfBusiness'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>6. ARE SUB-CONTRACTORS USED?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.areSubContractorsUsed.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.areSubContractorsUsed')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.areSubContractorsUsed.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.areSubContractorsUsed.details" label="% of work subcontracted" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>7. ANY WORK SUBLET WITHOUT CERTIFICATES OF INSURANCE?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyWorkSubletWithoutCertificatesOfInsurance'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>8. IS A WRITTEN SAFETY PROGRAM IN OPERATION?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.isWrittenSafetyProgramInOperation'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>9. ANY GROUP TRANSPORTATION PROVIDED?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyGroupTransportationProvided'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>10. ANY EMPLOYEES UNDER 16 OR OVER 60 YEARS OF AGE?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyEmployeesUnder16OrOver60YearsOfAge'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>11. ANY SEASONAL EMPLOYEES?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anySeasonalEmployees'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>12. IS THERE ANY VOLUNTEER OR DONATED LABOR?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.isThereAnyVolunteerOrDonatedLabor.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.isThereAnyVolunteerOrDonatedLabor')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.isThereAnyVolunteerOrDonatedLabor.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.isThereAnyVolunteerOrDonatedLabor.details" label="please specify" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>13. ANY EMPLOYEES WITH PHYSICAL HANDICAPS?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyEmployeesWithPhysicalHandicaps'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>14. DO EMPLOYEES TRAVEL OUT OF STATE?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.doEmployeesTravelOutOfState.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.doEmployeesTravelOutOfState')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.doEmployeesTravelOutOfState.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.doEmployeesTravelOutOfState.details" label="indicate state(s) of travel and frequency" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>15. ARE ATHLETIC TEAMS SPONSORED?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.areAthleticTeamsSponsored'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>16. ARE PHYSICALS REQUIRED AFTER OFFERS OF EMPLOYMENT ARE MADE?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.arePhysicalsRequiredAfterOffersOfEmploymentAreMade'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>17. ANY OTHER INSURANCE WITH THIS INSURER?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyOtherInsuranceWithThisInsurer'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>18. ANY PRIOR COVERAGE DECLINED / CANCELLED / NON-RENEWED IN THE LAST THREE (3) YEARS? (Missouri Applicants - Do not answer this question)</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyPriorCoverageDeclinedCancelledOrNonRenewedInTheLastThreeYears'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>19. ARE EMPLOYEE HEALTH PLANS PROVIDED?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.areEmployeeHealthPlansProvided'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>20. DO ANY EMPLOYEES PERFORM WORK FOR OTHER BUSINESSES OR SUBSIDIARIES?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.doAnyEmployeesPerformWorkForOtherBusinessesOrSubsidiaries'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>21. DO YOU LEASE EMPLOYEES TO OR FROM OTHER EMPLOYERS?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.doYouLeaseEmployeesToOrFromOtherEmployers'}
                options={['Yes', 'No']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>22. DO ANY EMPLOYEES PREDOMINANTLY WORK AT HOME?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.doAnyEmployeesPredominantlyWorkAtHome.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.doAnyEmployeesPredominantlyWorkAtHome')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.doAnyEmployeesPredominantlyWorkAtHome.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.doAnyEmployeesPredominantlyWorkAtHome.details" label="# of Employees" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>23. ANY TAX LIENS OR BANKRUPTCY WITHIN THE LAST FIVE (5) YEARS?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyTaxLiensOrBankruptcyWithinTheLastFiveYears.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.anyTaxLiensOrBankruptcyWithinTheLastFiveYears')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.anyTaxLiensOrBankruptcyWithinTheLastFiveYears.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.anyTaxLiensOrBankruptcyWithinTheLastFiveYears.details" label="please specify" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
        <Grid item xs={12}>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} sm={11}>
              <Typography>24. ANY UNDISPUTED AND UNPAID WORKERS COMPENSATION PREMIUM DUE FROM YOU OR ANY COMMONLY MANAGED OR OWNED ENTERPRISES?</Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFSelect
                name={'additionalQuestions.anyUndisputedAndUnpaidWorkersCompensationPremiumDueFromYouOrCommonlyManagedOrOwnedEnterprises.chosen'}
                options={['Yes', 'No']}
                onChange={(e) => handleChosenChange(e.target.value, 'additionalQuestions.anyUndisputedAndUnpaidWorkersCompensationPremiumDueFromYouOrCommonlyManagedOrOwnedEnterprises')}
              />
            </Grid>
          </Grid>
        </Grid>
        <FieldCondition fieldName="additionalQuestions.anyUndisputedAndUnpaidWorkersCompensationPremiumDueFromYouOrCommonlyManagedOrOwnedEnterprises.chosen" condition={(val) => val === 'Yes'}>
          <Grid item xs={12} sm={4}>
            <RHFTextField name="additionalQuestions.anyUndisputedAndUnpaidWorkersCompensationPremiumDueFromYouOrCommonlyManagedOrOwnedEnterprises.details" label="Explain including entity name(s) and policy number(s)" style={detailsFieldStyle} />
          </Grid>
        </FieldCondition>
      </Grid>
      <FormSectionControls step={'additional-questions'} />
    </FormProvider>
  );
};

export default Form;
